import { request } from '@/apis/http';
import {
  CommentAddReq,
  CommentQueryReq,
  CommentVO,
  DemandDataScreenVo,
  DemandOverviewKitchenVo,
  PageQuery,
  RegulatorDataScreenVo,
  SupplierStatisticsVo,
  SysMenuVo,
  ToolBoxCustomPageInfoVo,
  ToolBoxCustomPageVo,
  ToolBoxLargeScreenReq,
  ToolBoxLargeScreenVo,
  ToolBoxPopupAdInfoVo,
  ToolBoxPopupAdReq,
  ToolBoxPopupAdVo,
  ToolBoxPrintTemplateReq,
  ToolBoxPrintTemplateVo,
  TraceabilityDashboardVo,
  TravelMonitorVo,
} from 'typings/openapi';

export const UploadFileMethod = (params: any) => {
  return request<string>('/cosFile/uploading', {
    method: 'POST',
    data: params,
  });
};

export const GetScreenMethod = () => {
  return request<RegulatorDataScreenVo>('/home/regulator/dataScreen');
};

/** 监管大屏 - 食材溯源大屏 */
export const GetTraceabilityDashboard = (purchaseNo?: string) => {
  return request<TraceabilityDashboardVo>('/home/dashboard', {
    method: 'POST',
    data: purchaseNo ? { purchaseNo } : undefined,
  });
};

/** 监管大屏 - 行车监控视频列表 */
export const GetVehicleMonitorListMethod = (params?: { supplierId?: number; count?: number }) => {
  return request<TravelMonitorVo[]>('/home/travelMonitor', {
    method: 'GET',
    params,
  });
};

/** 监管大屏 - 明厨亮灶视频列表 */
export const GetBrightKitchenListMethod = (params?: { demandId?: number | null; count?: number }) => {
  return request<TravelMonitorVo[]>('/home/lightCooking', {
    method: 'GET',
    params,
  });
};

/** 监管大屏 - 供方监控视频列表 */
export const GetSupplyMonitorListMethod = (params?: { supplierId?: number; count?: number }) => {
  return request<TravelMonitorVo[]>('/home/supplierMonitor', {
    method: 'GET',
    params,
  });
};

export const GetScreenDemandMethod = () => {
  return request<DemandDataScreenVo>('/home/demand/dataScreen');
};

/** 需方后厨总览 */
export const GetScreenDemandKitchenMethod = () => {
  return request<DemandOverviewKitchenVo>('/home/demand/overviewKitchen');
};

/** 供方大屏 */
export const GetScreenSupplyMethod = () => {
  return request<SupplierStatisticsVo>('/home/supplier/dataScreen');
};

// 评论列表
export const GetCommentList = (data: CommentQueryReq) => {
  return request<PagingResponse<CommentVO>>('/comment/list', { method: 'POST', data });
};

export const AddComment = (data: CommentAddReq) => {
  return request('/comment/add', { method: 'POST', data });
};

export const DeleteComment = (id: number) => {
  return request(`/comment/${id}`, { method: 'POST' });
};

/** 获取大屏配置 */
export const GetCustomScreenParameterMethod = () => {
  return request<ToolBoxLargeScreenVo>('/toolbox/getLargeScreen');
};

/** 保存大屏配置 */
export const SaveCustomScreenParameterMethod = (data: ToolBoxLargeScreenReq) => {
  return request('/toolbox/updateLargeScreen', { method: 'POST', data });
};

/** 获取打印模板初始配置 */
export const GetPrintTemplateInitConfigMethod = () => {
  return request<ToolBoxPrintTemplateVo>('/toolbox/getPrintTemplateInitConfig');
};

/** 获取打印模板配置 */
export const GetCustomTemplateParameterMethod = () => {
  return request<ToolBoxPrintTemplateVo>('/toolbox/getPrintTemplate');
};

/** 更新打印模板配置 */
export const SaveCustomTemplateParameterMethod = (data: ToolBoxPrintTemplateReq) => {
  return request('/toolbox/updatePrintTemplate', { method: 'POST', data });
};

/** 获取自定义页面 */
export const GetCustomPageParameterMethod = (data: PageQuery) => {
  return request<PagingResponse<ToolBoxCustomPageInfoVo>>('/toolbox/getCustomPage', { method: 'POST', data });
};

/** 更新自定义页面 */
export const UpdateCustomPageParameterMethod = (data: ToolBoxCustomPageInfoVo) => {
  return request('/toolbox/updateCustomPage', { method: 'POST', data });
};

/** 删除自定义页面 */
export const DeleteCustomPageParameterMethod = (id: string) => {
  return request<ToolBoxCustomPageVo>('/toolbox/deleteCustomPage', { method: 'POST', data: { id } });
};

/** 根据ID获取url */
export const GetUrlByIdMethod = (id: string) => {
  return request<ToolBoxCustomPageInfoVo>('/toolbox/getUrlById', { params: { id } });
};

/** 一级菜单列表 */
export const GetMenuListMethod = (platformType: string) => {
  return request<SysMenuVo[]>(`/sysMenu/getFirstLevelMenuList/${platformType}`);
};

/** 获取弹窗广告 */
export const GetPopupAdMethod = () => {
  return request<ToolBoxPopupAdVo>('/toolbox/getPopupAd');
};

/** 更新弹窗广告 */
export const UpdatePopupAdMethod = (data: ToolBoxPopupAdReq) => {
  return request('/toolbox/updatePopupAd', { method: 'POST', data });
};

/** 获取当前用户需要展示的广告 */
export const GetCurrentUserPopupAdMethod = () => {
  return request<ToolBoxPopupAdInfoVo>('/toolbox/getCurrentUserPopupAd');
};
